import styled from 'styled-components';

import { interactiveCard } from '../../styles/mixins';

const Container = styled.div`
  ${interactiveCard}
  display: flex;
  justify-content: flex-start;
  margin-top: 2rem;
  max-height: 20rem;
  overflow: hidden;

  :hover img {
    transform: scale(1.05);
  }

  > div {
    display: flex;
    flex-direction: column;
    padding: 1.6rem 2rem 1.6rem 0;
    min-width: 0;
  }

  h2 {
    margin-top: 0.5rem;
  }
`;

const Situation = styled.div`
  border-radius: var(--r-pill);
  background-color: ${props => props.tagColor};
  margin: 1rem 0;
  align-self: flex-start;
  padding: 0.5rem 1.2rem;
  > p {
    color: ${props => props.textColor};
    font-size: 1.2rem;
    font-weight: 600;
  }
`;

const Image = styled.img`
  width: 40%;
  margin-right: 2rem;
  object-fit: cover;
  transition: transform var(--dur-base) var(--ease-out);
`;

const CreatedAt = styled.p`
  color: var(--ink-faint);
`;

const SeeProject = styled.p`
  color: var(--accent-deep);
  font-weight: 600;
  cursor: pointer;
  margin-top: auto;
  margin-bottom: 1rem;
  font-size: 1.6rem;
`;

export { Container, Image, CreatedAt, SeeProject, Situation };
